(function () {
    "use strict";

    angular
        .module("showcaseApp")
        .directive("modalNegotiationFilterContent", modalNegotiationFilterContent);

    /** @ngInject */
    function modalNegotiationFilterContent() {
        return {
            restrict: "E",
            scope: {
                filters: "=",
                options: "=",
                list: "=",
                isImmoContext: "=",
                onClose: "&",
                onExpose: "&",
                response: "="
            },
            controller: ModalNegotiationFilterContentController,
            controllerAs: "vm",
            bindToController: true,
            templateUrl: "app/components/modal/side-modal/body-contents/negotiation-filter/modal-negotiation-filter-content.html",
            link: function (scope, element, attrs, ctrl) {
                if (ctrl && typeof scope.vm.onExpose === 'function') {
                    scope.vm.onExpose({ methods: { applyFilters: ctrl.applyFilters, closeModal: ctrl.closeModal } });
                }
            }
        };
    }
})();
